import { render, staticRenderFns } from "./detailProperti.vue?vue&type=template&id=c1df127a&"
import script from "./detailProperti.vue?vue&type=script&lang=ts&"
export * from "./detailProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports